module.exports = __webpack_public_path__ + "static/img/管理者.0cca7ce6.png";